import * as React from 'react';
export const externalTestSvg = React.forwardRef(function externalTestSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11 1h4.25a.75.75 0 0 1 .75.75V6a.75.75 0 0 1-1.5 0V3.56l-2.97 2.97a.75.75 0 1 1-1.06-1.06l2.97-2.97H11A.75.75 0 1 1 11 1Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.5 15h7a2 2 0 0 0 2-2 4 4 0 0 0-4-4h-3a4 4 0 0 0-4 4 2 2 0 0 0 2 2ZM2 13a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5 2.5 2.5 0 0 0-2.5-2.5h-3A2.5 2.5 0 0 0 2 13Zm7-7.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-1.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z',
    }),
  );
});
externalTestSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var externalTest = {
  category: 'icon',
  colorable: true,
  name: 'externalTest',
  svg: externalTestSvg,
};
